import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export const migrateUserMethod = async (consent: boolean) => {
  try {
    const url = `${urls.migrateUser}/${consent ? "yes" : "no"}`;
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
